import { RequestType } from 'app/pages/order/redux/model/order-request';
import { RequestToExecute } from 'app/components/protected-content-without-completed-requests';
import { initializeShoppingCartActionCreator } from 'app/pages/order/redux/action-creators/initialize-shopping-cart-action-creator';

export const useInitializeShoppingCartRequest = (): RequestToExecute => ({
    requestType: RequestType.INITIALIZE_SHOPPING_CART,
    actionToDispatch: initializeShoppingCartActionCreator(),
});
